import { Module, GetterTree, MutationTree } from "vuex";

import { setValueByPath } from "@/shared/scripts/ValuesByPath";

import api from "./api";
import { RootState } from "../../store.interface";
import { Customer } from "@/shared/interfaces/customer/Customer.interface";
import { CustomerStoreState } from "@/shared/interfaces/customer/CustomerStoreState.interface";
import { Criterion } from "@/shared/interfaces/Criterion.interface";

const modules = {
    api: api,
};

const state: CustomerStoreState = {
    customers : [],
    currentCustomer: null,
    customerId: null,
    customerFormError: null,
    isChangeCustomerPhoneAlertModalVisible: false,
    initialCustomer: null,
    isCustomerContactDetailsChange: false,
};

const mutations: MutationTree<CustomerStoreState> = {
    setCustomers: function(state: CustomerStoreState, customers: Array<Customer>) {
        state.customers = customers;
    },
    resetCustomer: function(state:CustomerStoreState) {
        state.currentCustomer = null;
    },
    addCustomer: function(state: CustomerStoreState, customer: Customer):void {
        state.customers.push(customer);
    },
    setCurrentCustomer: function(state: CustomerStoreState, customer: Customer) {
        state.currentCustomer = customer;
    },
    selectCurrentCustomer: function(state: CustomerStoreState, index: number) {
        state.currentCustomer = state.customers[index];
    },
    setCustomerFormError: function(state: CustomerStoreState, error: Record<string, unknown>) {
        state.customerFormError = error;
    },
    setCustomerId: function(state: CustomerStoreState, customerId: string) {
        state.customerId = customerId;
    },
    resetCustomerFormError: function(state: CustomerStoreState) {
        state.customerFormError = null;
    },
    addValue: function(state: CustomerStoreState, criterion: Criterion) {
        setValueByPath(state.currentCustomer as Customer, criterion.path, criterion.value);
    },
    openChangeCustomerPhoneAlertModal: function(state: CustomerStoreState) {
        state.isChangeCustomerPhoneAlertModalVisible = true;
    },
    closeChangeCustomerPhoneAlertModal: function(state: CustomerStoreState) {
        state.isChangeCustomerPhoneAlertModalVisible = false;
    },
    setInitialCustomer: function(state: CustomerStoreState, customer: Customer) {
        state.initialCustomer = JSON.parse(JSON.stringify(customer));
    },
    setIsCustomerContactDetailsChange: function(state: CustomerStoreState, value: boolean) {
        state.isCustomerContactDetailsChange = value;
    },
};

const getters: GetterTree<CustomerStoreState, RootState> =  {
    /**
     * Only exists because `store.state` does not work in non-Vue scripts
     * (= other than components or stores) while `store.getters` does.
     *
     * See for example: src/shared/scripts/UploadPicture.ts
     */
    getCurrentCustomer: ((state): Customer => {
        return state.currentCustomer as Customer;
    }),
};

const customer: Module<CustomerStoreState, RootState> = {
    namespaced: true,
    modules: modules,
    state: state,
    mutations: mutations,
    getters: getters,
};

export default customer;
